<ng-container *ngIf="view as v">
  <!-- Catches every click, so nothing under the scrim can be used mid-tour. -->
  <div class="tour-blocker" aria-hidden="true"></div>
  <div #spotlight class="tour-spotlight" aria-hidden="true"></div>

  <section
    #card
    class="tour-card"
    role="dialog"
    aria-modal="true"
    aria-labelledby="tour-title"
    aria-describedby="tour-body"
    cdkTrapFocus
    (keydown)="onKeydown($event)">
    <div class="tour-head">
      <span class="tour-eyebrow">Quick tour · {{ progressLabel }}</span>
      <button mat-button type="button" class="tour-skip" (click)="skip()">Skip tour</button>
    </div>

    <div aria-live="polite">
      <h2 id="tour-title" class="tour-title">{{ v.step.title }}</h2>
      <p id="tour-body" class="tour-body">{{ v.step.body }}</p>
    </div>

    <div class="tour-foot">
      <span class="tour-dots" aria-hidden="true">
        <span *ngFor="let c of dotClasses" [class]="c"></span>
      </span>
      <span class="tour-actions">
        <button *ngIf="!v.isFirst" mat-stroked-button type="button" (click)="back()">Back</button>
        <button #primary mat-flat-button color="primary" type="button" (click)="next()">
          {{ primaryLabel }}
          <mat-icon *ngIf="!v.isLast" iconPositionEnd aria-hidden="true">arrow_forward</mat-icon>
        </button>
      </span>
    </div>
  </section>
</ng-container>
